import { JsonObject, JsonProperty } from 'json2typescript'
import DateConverter from '@/converters/DateConverter'
import { DefinedListDetail } from '../DefinedList'
import Model from '../Model'

@JsonObject('VehicleClaimModel')
export default class VehicleClaim extends Model {
  @JsonProperty('faultClaim', Boolean)
  faultClaim: boolean

  @JsonProperty('claimDate', DateConverter)
  claimDate: Date | null

  @JsonProperty('claimType', DefinedListDetail)
  claimType: DefinedListDetail

  @JsonProperty('claimAmount', Number)
  claimAmount: number | null

  constructor(
    id = 0,
    faultClaim = false,
    claimDate = new Date(),
    claimType = new DefinedListDetail(),
    claimAmount = 0,
  ) {
    super(id)
    this.faultClaim = faultClaim
    this.claimDate = claimDate
    this.claimType = claimType
    this.claimAmount = claimAmount
  }
}
